import axios from 'axios';

export default class NewsResource {
  calendarEvents(dateRange = { from: '', to: '',today:'' },locale) {
     return axios.get('/api/news/events?date_from='+dateRange.from+'&date_to='+dateRange.to+'&today='+dateRange.today+'&lang='+locale);
  }

  news(newsId) {
    return axios.get('/api/news/'+newsId);
  }
}
